export default import.meta.ROLLUP_FILE_URL_Sp6b81Mt;